module.exports = __webpack_public_path__ + "static/HeaderGrad-e18f7b8d2be4593f49de1951cfb488c1.png";